






























































import { Component, Vue, Prop } from "vue-property-decorator";
import { Form as elForm } from "element-ui";
import axios, { resHandle, axiosM } from "@/plugins/axios.ts";
import { validatePhone } from "@/plugins/elValidateRules.ts";
import { RegisterUser } from "@/types/user";
import { RegisterRules } from "../../access.d";
@Component({})
export default class RegisterView extends Vue {
  private window: any = window;
  private register: RegisterUser = {
    姓名: "",
    手机号: "",
    邀请码: "",
    密码: "",
    重复密码: "",
  };
  private rules: RegisterRules = {
    姓名: [{ required: true, message: "请输入姓名", trigger: "blur" }],
    手机号: [{ required: true, message: "手机号必须填写", trigger: "blur" }],
    邀请码: [{ required: true, message: "邀请码必须填写", trigger: "blur" }],
    密码: [{ required: true, message: "密码必须填写", trigger: "blur" }],
    重复密码: [{ required: true, message: "请再次输入密码", trigger: "blur" }],
  };
  private ifAllow: boolean = true;
  /**
   * @description 注册
   */
  private registerThis(): void {
    const reg = /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)(?=.*?[!@#$%^&*\_\-?.])[a-zA-Z\d!#@*&.]{8,}$/;
    const numberReg = /^1\d{10}$/;
    const passwordReg = reg.test(this.register["密码"]);
    // console.log(reg.test("As#1234567"));
    if (!numberReg.test(this.register["手机号"])) {
      this.$message.warning("手机号必须是11位数字格式");
      return;
    }
    if (!passwordReg) {
      this.$message.warning(
        "密码长度必须8位以上，且包含英文大小写和数字以及特殊字符"
      );
      return;
    }
    (this.$refs.registerForm as elForm).validate((isValid: boolean) => {
      if (isValid) {
        const params: any = this.register;
        axios.post("api/user/register", params).then(({ data }) => {
          resHandle(this, data).then(() => {
            this.$message.success("注册成功");
            this.$router.push("/access/login");
          });
        });
      }
    });
  }
  /**
   * @description 前往登录
   */
  private goToLogin(): void {
    this.$router.push("/access/login");
  }
}
